import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError, filter } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpFunctionsService } from '../http-services/http-functions.service';
import { CartListModel } from 'src/app/models/cart-list.model';
import { OrderDataModel, OrderListModel, OrderObject } from 'src/app/models/order-list.model';
import { FeedBackQuestionModel } from 'src/app/models/feedback.model';
import { SellerDataModel, SellerListModel } from 'src/app/models/seller-list.model';
import { CommonService } from '../Common-function/common.service';

@Injectable({
  providedIn: 'root'
})
export class CartService {
  beatCartUrl:string = 'cart/';
  orderUrl:string = 'order/';
  saleUrl:string = 'sale/';
  feedBaseUrl:string = 'feedback/';
  constructor(private httpService: HttpFunctionsService,
    private commonService: CommonService) {
  }

  insertCartData(data: any) {
    return this.httpService.postMethod(this.beatCartUrl + 'insert', data);
  }

  getCarts(): Observable<CartListModel> {
    return this.httpService.getMethod(this.beatCartUrl + 'list').pipe( map ((response: any) => {
      let cartListData: any = {};
      if (response.data && Object.keys(response.data).length) {
        cartListData = response.data
      }
      return cartListData;
    }),
    catchError(error => {
      return throwError(error);
    })
    );
  }

  deleteCartData(cartId: any) {
    return this.httpService.deleteMethod(this.beatCartUrl + `${cartId}/delete`);
  }

  /**
   * create Order
   * @param billingAddressId
   * @returns
   */
  createOrder(billingAddressId: string) {
    let sendData = {
      "billing_address_id": billingAddressId
    }
    return this.httpService.postMethod(this.orderUrl + 'insert', sendData);
  }

  /**
   * create Order
   * @param billingAddressId
   * @returns
   */
  getOrderList(filterData:any, iShowLoader:any): Observable<OrderDataModel> {
    return this.httpService.postMethod(this.orderUrl+'list',filterData, iShowLoader).pipe(map((orderRes: any) => {
      let sendData: any = { }
      if (orderRes.data) {
        sendData['orderListCount'] = orderRes.data.length;
        sendData['orderList'] = orderRes.data.length === 0 ? [] : orderRes.data;
        sendData['orderGroup'] = this.createArrayGroup(orderRes.data, 'orderList');
      }
      return sendData;
    }), catchError((error) => {
        return throwError(error);
    }));
  }

  /**
   * create array group data
   * @param orderArrayList
   * @returns
   */
  createArrayGroup(orderArrayList: Array<any>, keyName: string): Array<any> {
    let orderGroupArray: Array<any> = [];
    let orderDateGroup: any = {};
    orderDateGroup = orderArrayList.reduce((orderDateGroup: { [x: string]: any[]; }, orderObj: any) => {
      const date = orderObj.createdAt.split('T')[0];
      if (!orderDateGroup[date]) {
        orderDateGroup[date] = [];
      }
      orderDateGroup[date].push(orderObj);
      return orderDateGroup;
    }, {});
    if (Object.keys(orderDateGroup).length > 0) {
        Object.keys(orderDateGroup).map((orderDate) => {
        let tempArrayData: Array<any> = [];
        if (orderDateGroup[orderDate] && orderDateGroup[orderDate].length > 0) {
          tempArrayData = orderDateGroup[orderDate];
          if (keyName === "sellerList") {
            tempArrayData = tempArrayData.filter((orderDataObj: any) => orderDataObj.payment_transfer_status !== "pending");
          }
        }
        if (tempArrayData.length > 0 ) {
          orderGroupArray.push({
            date: orderDate,
            [keyName]: tempArrayData
          });
        }
      });
    }

    return orderGroupArray;
  }
  /**
   * call particular order api  with the help of order id
   * @param
   * @returns
   */
  getParticularOrderData(orderId:any): Observable<Array<OrderObject>> {
    let filterData = {
      "filter": {
        "order_id": orderId,
      }
    }
    return this.httpService.postMethod(this.orderUrl+'list',filterData).pipe(map( (orderRes: any) => {
        let orderArray: Array<OrderObject> =  []
        if (orderRes.data && orderRes.data.length > 0) {
          orderArray =  orderRes.data;
        }
        return orderArray;
    }), catchError((error) => {
      return throwError(error)
    }));
  }

    /**
     * create Order
     * @param Get Selling list for Producer
     * @returns
     */
    getSaleList(sendData: any, iShowLoader: boolean = true, type: any = ""): Observable<SellerDataModel> {
      return this.httpService.postMethod(this.saleUrl+'list', sendData, iShowLoader).pipe(
        map((sellingRes: any) => {
          if (type) {
            return sellingRes;
          } else {
            let sendObjData: any = { }
            if (sellingRes.data) {
              sendObjData['sellerListCount'] = sellingRes.data.length;
              sendObjData['sellerList'] = sellingRes.data.length === 0 ? [] : sellingRes.data;
              sendObjData['sellerGroup'] = sellingRes.data.length === 0 ? [] : this.createArrayGroup(sellingRes.data, 'sellerList');
            }
            return sendObjData;
          }
         
      }), catchError((error) => {
        return throwError(error);
      }));
    }

    paymentSubmit(sendData: any) {
      return this.httpService.postMethod('payment/submit', sendData);
    }

  /**
   * apply Coupon
   * @param couponCode
   * @returns
   */
  applyCoupon(couponCode: any): Observable<CartListModel> {
    let body = {
      "coupon_code": couponCode
    }
    return this.httpService.postMethod(this.beatCartUrl + 'apply-coupon', body).pipe( map((res: any) => {
      let cartObj: any = {}
      if (res.data) {
        this.commonService.cartDataList.next(res.data);
        cartObj = res.data;
      }
      return cartObj;
    }),catchError(( error) => {
       return throwError(error);
    }));
  }

  removeCoupon() {
    return this.httpService.deleteMethod(this.beatCartUrl + `remove-coupon`).pipe( map((res: any) => {
      let cartObj: any = {}
      if (res.data) {
        this.commonService.cartDataList.next(res.data);
        cartObj = res.data;
      }
      return cartObj;
    }),catchError(( error) => {
       return throwError(error);
    }));
  }

  /**
   * Guest cart preview — calls backend to get fully computed cart totals
   * for guest users without creating any order or persisting data.
   * Returns the same CartListModel shape as getCarts().
   * @param items - Array of {beat_id, beat_price} or {sound_id, sound_price}
   * @param couponCode - Optional coupon code to apply
   */
  getGuestCartPreview(items: any[], couponCode?: string): Observable<CartListModel> {
    const body: any = { items };
    if (couponCode) {
      body.coupon_code = couponCode;
    }
    return this.httpService.postMethod(this.beatCartUrl + 'guest-preview', body, false).pipe(
      map((res: any) => {
        let cartListData: any = {};
        if (res.data && Object.keys(res.data).length) {
          cartListData = res.data;
        }
        return cartListData;
      }),
      catchError(error => {
        return throwError(error);
      })
    );
  }

    /**
   *
   * @returns get feed back question
   */
  getFeedBackQuestion() {
    return this.httpService.getMethod(this.feedBaseUrl+'list').pipe(map(feedbackRes => {
      let feedBackQuestion: Array<FeedBackQuestionModel> = [];
      if (feedbackRes?.data &&  feedbackRes.data.length > 0) {
        feedBackQuestion = feedbackRes.data;
      }
      return feedBackQuestion;
    }), catchError((error) => {
      return throwError(error)
    }));
  }

  /**
   *
   * @returns get feed back question
   */
  submitFeedBackQuestion(sendData:any) {
    return this.httpService.postMethod(this.feedBaseUrl+'addFeedback',sendData);
  }

  /**
   *
   * @returns get feed back question
   */
  submitHelp(sendData:any) {
    return this.httpService.postMethod(this.feedBaseUrl+'addHelp',sendData);
  }

  /**
   * Get feedback List
   * @returns
   */
  getFeedBackList() {
    return this.httpService.getMethod(this.feedBaseUrl+'list');
  }
  /**
   * Get feedback List
   * @returns
   */
  getFeedBackAllList() {
    return this.httpService.getMethod(this.feedBaseUrl+'getFeedbacks');
  }

  getActiveHelpsList(callingType: string, pageNumber: number, isShowLoader: boolean  = true) {
    if (callingType) {
      let sendData = {
        pageNumber: pageNumber,
        limit: 10
      }
      return this.httpService.postMethod(this.feedBaseUrl+'getAllHelp',sendData, isShowLoader);
    } else {
      return this.httpService.getMethod(this.feedBaseUrl+'getActiveHelp');
    }
  }

  /**
   * Resolve help Api
   * @param helpId
   * @returns
   */
  resolveHelp(helpId:any) {
    let sendData = {
      help_id : helpId
    }
    return this.httpService.postMethod(this.feedBaseUrl+'resolveHelp', sendData);
  }
/**
 * Download free sound
 * @param soundId 
 * @returns Observable
 */
downloadFreeSound(soundId: string): Observable<any> {
  return this.httpService.postMethod(`sounds/${soundId}/download-free`, {});
}

  purchaseSoundWithCredit(soundId: any) {
    return this.httpService.postMethod(`sounds/${soundId}/purchase-with-credits`, {});
  }

  /**
   * Guest checkout — creates a guest account + order + Razorpay order
   * without authentication. POST /order/guest-checkout
   * @param payload - items, billing info, and optional coupon_code
   */
  guestCheckout(payload: any): Observable<any> {
    return this.httpService.postMethod('order/guest-checkout', payload);
  }

  /**
   * Claim a guest account after successful Razorpay payment.
   * Logs the guest in by returning tokens identical to /auth/signin.
   * POST /auth/claim-guest-account
   * @param razorpayData - razorpay_order_id, razorpay_payment_id, razorpay_signature
   */
  claimGuestAccount(razorpayData: {
    razorpay_order_id: string;
    razorpay_payment_id: string;
    razorpay_signature: string;
  }): Observable<any> {
    return this.httpService.postMethod('auth/claim-guest-account', razorpayData);
  }

  /**
   * Direct buy for authenticated users.
   * POST /order/buy-now
   */
  buyNow(payload: any): Observable<any> {
    return this.httpService.postMethod(this.orderUrl + 'buy-now', payload);
  }

  /**
   * Direct buy for guest users without an account.
   * POST /order/guest-buy-now
   */
  guestBuyNow(payload: any): Observable<any> {
    return this.httpService.postMethod(this.orderUrl + 'guest-buy-now', payload);
  }

}
